import { Component, Input, OnInit } from '@angular/core';
import { ReportProblemService } from './report-problem.service';

@Component({
  selector: 'giq-report-problem',
  templateUrl: 'report-problem.component.html',
  styleUrls: ['report-problem.component.scss'],
  standalone: false,
})
export class ReportProblemComponent implements OnInit {
  constructor(private service: ReportProblemService) {}

  @Input() id: string | undefined;
  @Input() type: string | undefined;
  @Input() description: string | undefined;

  ngOnInit() {}

  public openWindow() {
    this.service.show(this.id, this.type, this.description);
  }
}
